const KEY = 'ToolBoxJwt';

const get = (key = KEY) => typeof window !== 'undefined' && localStorage.getItem(key);
const set = (value, key = KEY) => localStorage.setItem(key, value);
const remove = (key = KEY) => localStorage.removeItem(key);
const isLoggedIn = () => get();

export default {
  set,
  get,
  remove,
  isLoggedIn,
};
